<!--
Author: TangChen
Date: 2018-11-09
Desc: 用户持有银行卡信息组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-hold-bank bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="hold-bank-list" :gutter="10">
            <el-col v-for="(bank, index) in bankInfo" :key="index" :span="6">
                <el-card class="bank-card" :class="bank.status!=='1'?(colorBlue.indexOf(bank.bankid) > -1?'blue':'red'):''">
                    <div v-if="bank.status==='0' && bank.hkopenflag==='1'" class="hk">
                        <div
                            class="cursor add-bank-btn"
                            v-on:click.prevent="addHK(bank)"
                        >
                            <el-tag type="info" color="white"><span style="font-weight: bold">添加汇款卡</span></el-tag>
                        </div>
                    </div>
                    <div v-else-if="bank.status==='4' || bank.status==='6'" class="review-status">
                        {{ bank.status==='4' ? "审核中" : "审核失败" }}
                    </div>
                    <div class="bank-info">
                        <div class="bank-img">
                            <img :src="$util.getImg(bank.bankid)" alt="">
                        </div>
                        <div class="bank-name">
                            <span class="t">{{ $cache.getDict('150003',bank.bankid) }}</span>
                            <span class="c">{{ $cache.getDict('110079',bank.paycenterid)+(bank.hkcardflag==='1'?'(汇款支付)':'(在线支付)') }}</span>
                        </div>
                    </div>
                    <p class="bank-num">
                        {{ $util.getNewCard(bank.bankcard) }}
                    </p>
                    <div v-if="bank.status==='0'" class="bank-action">
                        <!--mod by zhangqc 20201122 汇款卡不支持签约解约-->
                        <el-button
                            v-if="bank.allowsign==='1'&&bank.signstatus==='0'&&bank.authstatus!=='0'&&bank.hkcardflag!=='1'"
                            size="mini"
                            v-on:click.once="$router.push({name:'signbank',query:bank})"
                        >
                            签约
                        </el-button>
                        <el-button
                            v-if="bank.allowunsign==='0'&&bank.signstatus==='1'&&bank.authstatus!=='0'&&bank.hkcardflag!=='1'"
                            size="mini"
                            v-on:click.once="$router.push({name:'unsignbank',query:bank})"
                        >
                            解约
                        </el-button>
                        <el-button v-if="bank.authstatus==='0'" size="mini" v-on:click.once="$router.push({name:'activebank',query:bank})">
                            激活
                        </el-button>
                        <el-button v-if="bank.status!=='1'&&bank.authstatus!=='0'" size="mini" v-on:click.once="$router.push({name:'modifybank',query:bank})">
                            修改
                        </el-button>
                        <!-- <el-button v-if="bank.authstatus==='1'&&bank.authstatus!=='0'" size="mini" v-on:click.once="$router.push({name:'changebank',query:bank})">
                            换卡
                        </el-button> -->
                        <el-button
                            v-if="!(bankInfo.length===1 && isdellastcard==='0')"
                            size="mini"
                            v-on:click="deleteBank(bank.moneyaccount)"
                        >
                            删除
                        </el-button>
                    </div>
                    <div v-else-if="bank.status==='6'" class="bank-action">
                        <el-button
                            size="mini"
                            v-on:click.once="$router.push({name:'addbank',query:bank})">
                            重新上传
                        </el-button>
                        <el-button
                            size="mini"
                            v-on:click="deleteRemitBank(bank)"
                        >
                            删除
                        </el-button>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="6">
                <el-card class="bank-card add" :class="{'grey':bankInfo.length===0}">
                    <div v-on:click="$router.push({name:'addbank'})">
                        <i class="fa fa-plus-circle" />
                        <p class="other">
                            {{ bankInfo.length===0?'暂无可用，':'' }}添加银行卡
                        </p>
                        <p class="more">
                            支持多家银行卡
                        </p>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="银行卡删除" :visible.sync="dialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" /><span>此操作将永久删除该银行卡
                            {{ isPwdCheck?'，输入交易密码进行删除':'' }}！</span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="deleteBankCon(deleteId)">
                    删除
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加汇款卡" :visible.sync="visible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p>
                        <i class="el-icon-warning" /><span>是否添加{{ $cache.getDict('150003',hkId.bankid)+'的汇款卡' }}！</span>
                    </p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item v-if="isPwdCheck" label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="visible = false">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="addHKCon(hkId.moneyaccount)">
                    添加
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "HoldBank",
    mixins: [mixin],
    data () {
        return {
            bankInfo: [],
            dialogVisible: false,
            visible: false,
            isPwdCheck: false,
            hkId: "",
            isdellastcard: "",
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            allowchange: "",
            deleteId: "",
            // 蓝色背景：建设银行、交通银行、民生银行、兴业银行、农业银行、@农村信用社、@浦发银行、@上海银行、@上海农商银行、@深圳银行、@杭州银行、@汉口银行、@中国银联
            colorBlue: "103,105,301,305,309,325,A40,310,325"
        };
    },
    mounted () {
        this.getBankInfo();
    },
    methods: {
        // 删除的银行卡
        deleteBank (id) {
            this.deleteId = id;
            this.dialogVisible = true;
            this.isPwdCheck = this.$cache.getPwdCheck("B6");
            if (this.$refs.ruleForm) {
                this.$refs.ruleForm.resetFields();
            }
        },
        addHK(bank){
            this.visible = true;
            this.hkId = bank;
            this.isPwdCheck = this.$cache.getPwdCheck("A3");
            if (this.$refs.ruleForm) {
                this.$refs.ruleForm.resetFields();
            }
        },
        addHKCon(id){
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    this.$util.request("acct/bank/addhkcard", { moneyaccount: id, tradepwd: _pwd, hkpaycenterflag: "0" }, "POST").then(res => {
                        if (res.data) {
                            _this.visible = false;
                            _this.getBankInfo();
                            _this.$message({
                                type: "success",
                                message: "增加汇款卡成功!"
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 删除银行卡
        deleteBankCon (id) {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    this.$util.request("acct/bank/card", { moneyaccount: id, tradepwd: _pwd }, "DELETE").then(res => {
                        if (res.data) {
                            _this.dialogVisible = false;
                            _this.getBankInfo();
                            _this.$message({
                                type: "success",
                                message: "银行卡删除成功!"
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        deleteRemitBank (bank) {
            const data = {
                hkopenflag: "1",
                hkpaycenterflag: "1",
                checkaction: "2",
                bankid: bank.bankid,
                channelid: bank.channelid,
                depositprov: bank.bankprovince,
                depositcity: bank.bankcity,
                bankname: bank.branchname,
                paycenterid: bank.paycenterid,
                channelname: bank.channelname,
                moneyaccount: ""
            };
            const _this = this;
            _this.$util.request("acct/bank/addhkcard", data, "POST").then(res => {
                if (res.data) {
                    _this.dialogVisible = false;
                    _this.getBankInfo();
                    _this.$message({
                        type: "success",
                        message: "银行卡删除成功!"
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getBankInfo () {
            this.$util.request("acct/bank/card").then(res => {
                if (res.data) {
                    const list = res.data[0] ? res.data[0] : [];
                    this.bankInfo = list.sort((a, b) => a.bankid - b.bankid);
                    if (res.data[1]) {
                        this.isdellastcard = res.data[1][0].isdellastcard;
                        this.allowchange = res.data[1][0].allowchangecard;
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/* 用户持有银行卡信息 */
.bizcomp-hold-bank {
    overflow: hidden;
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                color: $color-a;
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .redemp-btn{margin-left: 3%;}
    .manage-bank {
        text-align: center;
        font-size: $f18;
        line-height: 30px;
        padding: 20px 0;
        border-top: 1px solid $border-color3;
    }
    .el-row.hold-bank-list {
        padding: 11px 25px 26px;
        .el-col .bank-card {
            cursor: pointer;
            position: relative;
            height: 150px;
            margin-top: 20px;
            border-radius: 4px;
            background-color: #a1a1a1;
            box-shadow: 0 1px 2px 1px #a1a1a1;
            color: $text-color6;
            border: none;
            .hk{
                position: absolute;
                right: 20px;
                top: 20px;
                font-size: 12px;
                line-height: 22px;
                .add-bank-btn {
                    margin-top: -15px;
                }
            }
            .review-status {
                position: absolute;
                right: 10px;
                top: 10px;
                padding: 0 5px;
                height: 22px;
                border-radius: 5px;
                border: 1px solid white;
                text-align: center;
                font-size: 12px;
                line-height: 22px;
            }
            .bank-info {
                margin-bottom: 15px;
                .bank-img {
                    width: 44px;
                    height: 44px;
                    display: inline-block;
                    vertical-align: middle;
                    text-align: center;
                    border-radius: 100px;
                    background-color: $bg2;
                    padding: 7px;
                    box-sizing: border-box;
                    img {
                        width: 30px;
                        height: 30px;
                    }
                }
                .bank-name {
                    margin-left: 8px;
                    display: inline-block;
                    vertical-align: middle;
                    span {
                        display: block;
                        &.t {
                            font-size: $f16;
                        }
                    }
                }
            }
            .bank-num {
                font-size: $f18;
            }
            &.blue {
                background-color: $color-b-l;
                box-shadow: 0 1px 2px 1px $color-b-l;
                .bank-action .el-button {
                    background-color: $color-b-l;
                }
            }
            &.red {
                background-color: $color-c-m;
                box-shadow: 0 1px 2px 1px $color-c-m;
                .bank-action .el-button {
                    background-color: $color-c-m;
                }
            }
            &.add {
                &.grey {
                    background-color: #a1a1a1;
                    box-shadow: 0 1px 2px 1px #a1a1a1;
                }
                background-color: $color-a-s;
                box-shadow: 0 1px 2px 1px $color-a-s;
                text-align: center;
                i {
                    font-size: 44px;
                    line-height: 44px;
                }
                p.other {
                    font-size: $f18;
                    margin-top: 10px;
                    line-height: 30px;
                }
                p.more {
                    line-height: 32px;
                }
            }
            .bank-action {
                padding-top: 10px;
                text-align: center;
                .el-button--default {
                    padding: 6px 10px;
                    color: $text-color6;
                    background-color: inherit;
                    border-color: $text-color6;
                    &:hover {
                        color: $color-a-s;
                        border-color: $color-a-s;
                    }
                }
            }
        }
    }
}
</style>
